<template>
  <div>
    <a
      class="form-action-text text-secondary px-0"
      v-b-modal="`move-be-feature-${entity.id}`"
    >
      Move Feature
    </a>
    <b-modal
      ref="MoveBEModal"
      :id="`move-be-feature-${entity.id}`"
      centered
      size="lg"
      title="Move Feature to Other Property"
      @hide="hideModal"
    >
      <form @submit.prevent class="needs-validation" novalidate autocomplete="off">
        <div v-if="!moveFeatureConfirmation" class="form-group row mb-0">
          <div class="col-4">
            <label for="destinationPropertyId" class="label-text col-form-label">
              Destination Property ID
            </label>
          </div>
          <div class="col-8">
            <input class="form-control"
              v-validate="'required|numeric|current_property_exists|is_not:' + entity.propertyId"
              name="destinationPropertyId"
              data-vv-as="Destination Property ID"
              placeholder="Enter Destination Property ID"
              v-model="destinationPropertyId"
            />
            <div class="invalid-feedback">{{errors.first('destinationPropertyId')}}</div>
          </div>
        </div>
        <p v-if="moveFeatureConfirmation">
          Are you sure you want to move <b>{{entity.description}}</b> (ID {{entity.id}})
          from Current Property {{entity.propertyId}}
          to Property {{destinationPropertyId + getProjectString()}}?
        </p>
      </form>
      <div slot="modal-footer" class="d-flex justify-content-center w-100">
        <template v-if="!moveFeatureConfirmation">
          <b-button variant="danger" class="button-row-spacing" @click="hideModal">Cancel</b-button>
          <b-button v-if="!moveFeatureConfirmation" class="button-row-spacing" @click="confirmMove">
            Move Feature
          </b-button>
        </template>
        <template v-if="moveFeatureConfirmation">
          <b-button variant="danger"
            class="button-row-spacing"
            @click="moveNotConfirmed"
            :disabled="submitting"
          >
            No
          </b-button>
          <b-button class="button-row-spacing"
            @click="submitWrapper(entity, destinationPropertyId)"
            :disabled="submitting"
          >
            Yes, Move the Feature
          </b-button>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import { EntityModules } from '@/store/moduleConfig';
import FormSubmit from '@/mixins/FormSubmit';

function initialState() {
  return {
    destinationPropertyId: null,
    moveFeatureConfirmation: false,
    destinationProperty: {},
  };
}

export default {
  name: 'MoveBEModal',
  mixins: [FormSubmit],
  props: ['entity', 'submitCallback'],
  data() {
    return initialState();
  },
  computed: {
    ...mapState(EntityModules.BUILT_ENVIRONMENT_FEATURE.namespace, {
      submitting: state => state.submitting,
    }),
  },
  methods: {
    submitWrapper(entity, destinationPropertyId) {
      const submittedFeature = {};
      Object.assign(submittedFeature, entity);
      submittedFeature.propertyId = destinationPropertyId;
      this.onSubmit(
        submittedFeature,
        EntityModules.BUILT_ENVIRONMENT_FEATURE.namespace,
        null,
        this.submitted,
      );
    },
    submitted() {
      this.$store.dispatch(
        `${EntityModules.BUILT_ENVIRONMENT_FEATURE.namespace}/fetchEntities`, {
          parentType: EntityModules.BUILT_ENVIRONMENT_FEATURE.parentType,
          parentId: parseInt(this.$route.params.property_id, 10),
          entityType: EntityModules.BUILT_ENVIRONMENT_FEATURE.entityType,
        },
      ).then(this.submitSuccess);
    },
    hideModal() {
      this.$refs.MoveBEModal.hide();
      Object.assign(this.$data, initialState());
    },
    confirmMove() {
      this.$validator.validate()
        .then((result) => {
          if (result) {
            api.get(`/property/${this.destinationPropertyId}`)
              .then((response) => {
                this.destinationProperty = response.data;
                this.moveFeatureConfirmation = true;
              });
          }
        });
    },
    submitSuccess() {
      this.refetchMoveToProperty();
      this.submitCallback();
    },
    moveNotConfirmed() {
      this.moveFeatureConfirmation = false;
    },
    getProjectString() {
      if (this.destinationProperty.projectId !== parseInt(this.$route.params.project_id, 10)) {
        return ` on Project ${this.destinationProperty.projectId}`;
      }
      return '';
    },
    refetchMoveToProperty() {
      this.$store.dispatch('Property/refetchDestinationProperty', this.destinationPropertyId);
    },
  },
};
</script>
